import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DiaryFormConditionExpression } from "../../../../../../core/models/trial-diary-form/diary-form-rule.model";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { SelectOption } from "../../../../../../core/models/select-option.model";
import { SharedModule } from "../../../../../../shared/shared.module";
import { DiaryFormElement } from "../../../../../../core/models/trial-diary-form/diary-form-element.model";
import { ButtonComponent } from "../../../../../../shared/button/button.component";
import { BaseComponent } from "../../../../../../shared/base-component";
import { InputSelectComponent } from "../../../../../../shared/input-select/input-select.component";

@Component({
  selector: 'app-trial-diary-add-rule-condition',
  standalone: true,
  imports: [
    SharedModule,
    ButtonComponent,
    ReactiveFormsModule
  ],
  templateUrl: './trial-diary-add-rule-condition.component.html',
  styleUrl: './trial-diary-add-rule-condition.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class TrialDiaryAddRuleConditionComponent extends BaseComponent implements AfterViewInit {
  @ViewChild('elementIdSelect') elementIdSelect: InputSelectComponent;
  @ViewChild('valueSelect') valueSelect: InputSelectComponent;

  @Output() remove = new EventEmitter();

  @Input() expression: DiaryFormConditionExpression = new DiaryFormConditionExpression();
  @Input() elements: DiaryFormElement[] = [];
  @Input() elementOptions: SelectOption[] = [];
  @Input() logicalOperator: string = '';

  protected form = new FormGroup({
    operator: new FormControl<string>("EQUALS"),
    value: new FormControl<string>(null),
    elementId: new FormControl<string>(null)
  });
  protected operatorOptions: SelectOption[] = [
    new SelectOption('EQUALS', '=')];
  protected valueOptions: SelectOption[] = [];

  ngAfterViewInit(): void {
    if (this.expression && this.expression.elementId) {
      this.buildValueOptions(this.expression.elementId);

      this.form.patchValue({
        elementId: this.expression.elementId,
        operator: this.expression.operator,
        value: this.expression.value
      })
    }

    this.form.valueChanges.subscribe(value => {
      this.expression.elementId = value.elementId;
      this.expression.operator = value.operator;
      this.expression.value = value.value;
    });

    this.form.get('elementId').valueChanges.subscribe(value => {
      this.buildValueOptions(value);
    });
  }

  buildValueOptions(elementId: string) {
    this.valueOptions = [];
    if (!elementId || elementId === '')
      return;

    const element = this.elements.find(e => e.id.toString() === elementId);
    if (element.options && element.options.length > 0)
      this.valueOptions = element.options.map(o => ({value: o.id.toString(), text: o.text}));
  }

  removeCondition() {
    this.remove.emit();
  }
}
